module.exports = "https://cdn.redage.net/src/views/player/help/images/burger2.jpg";